export default __webpack_public_path__ + "cockroach-topview-Lbrown.png?71328bc5902cf39ee7647ea2534947cc";